<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Search Customers</h3>
    </v-flex>
    <v-col xs12 pt-2 class="search-fields" v-on:keyup.enter="search">
      <v-text-field v-model="query.search" label="Search"></v-text-field>
      <v-checkbox
        v-model="query.lockedOut"
        color="primary"
        class="small-label"
        label="Locked Out Users"
      ></v-checkbox>
      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
      <v-flex pt-2>
        <router-link to="/customers/create">
          <h4>Register Customer</h4>
        </router-link>
      </v-flex>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  name: "customer_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {};
  },
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
